import useScrollToTop from "global/hooks";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const usePageLayout = () => {
  const pathname = useLocation().pathname;
  useScrollToTop();

  const isHomePage = useMemo(() => pathname === "/", [pathname]);

  return { isHomePage, pathname };
};

export default usePageLayout;
